export default "__VITE_ASSET__CDB8Zu_o__"